// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gDTDz","importantInfo":"styles_importantInfo__19gY6"};